import { Component, OnInit, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DataService } from '../services/data.service';
import { FileUploadControl, FileUploadValidators } from '@iplab/ngx-file-upload';
import { Storage, getDownloadURL, ref, uploadBytesResumable } from '@angular/fire/storage';

@Component({
  selector: 'app-event',
  templateUrl: './event.page.html',
  styleUrls: ['./event.page.scss'],
})
export class EventPage implements OnInit {

  name: any;
  description: any;
  venue: any;
  address: any;
  content: any;
  date: any;
  end: any;
  image: any;
  artists: any[];
  logos: any[];
  url: any;
  _types: any;
  types: any;
  type: any;

  isDefaultDate = (dateString: string) => {
    const date = new Date(dateString);
    return date;
  };

  public fileUploadControl = new FileUploadControl(null, FileUploadValidators.filesLimit(1));
  public uploadedFiles: Array<File> = [];
  private storage: Storage = inject(Storage);

  constructor(
    private modalController: ModalController,
    private dataService: DataService
  ) { }

  close(){
    this.modalController.dismiss();
  }

  addImage(val){
    let reader = new FileReader();
      reader.onload = async ()=>{
        let dataURL = reader.result;
        //console.log(dataURL);
        let b = await fetch(<any>dataURL);
        let blob = await b.blob();
        const storageRef = ref(this.storage, Math.random() + val.name);
        const up = uploadBytesResumable(storageRef, <any>blob);
        await up;
        let url = await getDownloadURL(up.snapshot.ref);
        this.url = url;
        this.fileUploadControl = new FileUploadControl(null, FileUploadValidators.filesLimit(1));
      };
      reader.readAsDataURL(val);
  }

  addArtist(){

  }

  addLogo(){

  }

  addEvent(){
    this.dataService.addEvent(this.name, this.description, this.content, this.venue, this.address, this.date, this.end, this.url, this.type);
    this.close();
  }

  ngOnInit() {
  }

  ionViewDidEnter(){
    let date = Date.now()
    this.date = new Date(date).toISOString();
    this.end = new Date(date).toISOString();
    this.fileUploadControl.valueChanges.subscribe(val=>{
      console.log(val);
      if(val && val[0]){
        //this.upload = true;
        this.addImage(val[0]);
      }
    });
    this._types = this.dataService.types.subscribe(val=>{
      if(val){
        this.types = val;
      }
    })
  }

  ionViewWillLeave(){
    this._types.unsubscribe();
  }

}
